import { render, staticRenderFns } from "./apply-for.vue?vue&type=template&id=d1710afc&scoped=true"
import script from "./apply-for.vue?vue&type=script&lang=js"
export * from "./apply-for.vue?vue&type=script&lang=js"
import style0 from "./apply-for.vue?vue&type=style&index=0&id=d1710afc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1710afc",
  null
  
)

export default component.exports